/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
//Copied from VPC
import * as CertificationWatermark from '@tableau/certification-watermark';
import { CertificationStatusChipOrIcon } from '@tableau/data-catalog-client-components';
import { SiteUrls } from '@tableau/shared-urls';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { imgPath } from '../../../../common/utils/ImgUrl';

const CERTIFIED_INDICATOR_TYPE = 'CERTIFIED';
export interface CertificationCellOptions {
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row, siteUrls: SiteUrls) => CertificationWatermark.CertificationTooltipProps;
}

const CertificationCellStyle: React.CSSProperties = {
  position: 'relative',
  left: '11px',
  top: '2px',
};

export function CertificationCell(siteUrls: SiteUrls, options: CertificationCellOptions): React.Factory<BodyCell.Props> {
  return React.createFactory(
    class CertificationCell extends React.Component<BodyCell.Props, any> {
      render() {
        if (!options.isCertified(this.props.row)) {
          return null;
        }
        let indicator;
        if (this.props.row.data.contentType === 'unifieddatasource') {
          const indicators = this.props.row.data.contentDetail.dataQualityIndicators.filter(
            (i: { type: string }) => i.type === CERTIFIED_INDICATOR_TYPE
          );
          indicator = indicators[0];
        } else if (this.props.row.data.contentType === 'database' || this.props.row.data.contentType === 'table') {
          indicator = this.props.row.data.dataQualityCertifications[0];
          if (indicator) {
            indicator.type = indicator.warningType;
          }
        }

        if (!indicator) {
          const icon = <img src={imgPath('Certified-18px-large.svg')} alt={'Certification'} className={'CertificationCell'} />;
          const tooltipProps = { ...options.getTooltipProps(this.props.row, siteUrls), icon: icon };
          const iconWrapper = <CertificationWatermark.CertificationTooltipComponent {...tooltipProps} />;
          return (
            <div style={{ position: 'relative', top: '5px' }} className={'CertificationCell'}>
              {iconWrapper}
            </div>
          );
        }

        const assetType = this.props.row.data.contentType === 'datasource' ? 'PublishedDatasource' : this.props.row.data.__typename;
        const siteUrlsWrapper = siteUrls ? siteUrls : new SiteUrls({ siteUrlName: '' });

        return (
          <span className="tb-certification-cell" data-tb-test-id="CertificationCell" style={CertificationCellStyle}>
            <CertificationStatusChipOrIcon
              subjectArea={this.props.row.data.contentType}
              kind={'vizportal'}
              anchoredAsset={{
                assetName: this.props.row.data.name,
                assetType: assetType,
                assetUrl: (urls) => urls.datasourceUrl(this.props.row.data.id),
              }}
              anchoredCertifications={[dataQualityIndicatorInfoToDataQualityIndicator(indicator)]}
              iconOnly={true}
              urls={siteUrlsWrapper}
            />
          </span>
        );
      }
    }
  );
}

export function dataQualityIndicatorInfoToDataQualityIndicator(
  indicator: IDataQualityIndicatorInfo
): IDataQualityIndicatorDefinedInVizportalWebclientApi {
  const { owner, ...rest } = indicator;
  const user = dataQualityOwnerToTableauUser(owner);

  return {
    ...rest,
    owner: {
      domain: user.domain!,
      domainName: user.domain!,
      username: user.username!,
      displayName: user.name!,
      authId: '',
      id: '',
    },
  };
}

export function dataQualityOwnerToTableauUser(owner: DataQualityOwner | null | undefined): TableauUser {
  if (!owner) {
    return { username: null, domain: null, name: null };
  }

  return {
    username: owner.username || null,
    name: owner.displayName || null,
    domain: owner.domainName || null,
  };
}

export interface IDataQualityIndicatorInfo {
  isActive: boolean;
  isSevere: boolean;
  type: string;
  message: string;
  updatedAt?: Date;
  owner: DataQualityOwner;
  id: string;
}

export type DataQualityOwner = {
  username: string | null;
  displayName: string | null;
  domainName?: string | null;
};

export interface TableauUser {
  /**
   * Username of this user
   */
  username: string | null;
  /**
   * Display name of this user
   */
  name: string | null;
  /**
   * Domain this user belongs to
   */
  domain: string | null;
}

export type IDataQualityIndicatorDefinedInVizportalWebclientApi = {
  id: string;
  isActive: boolean;
  isSevere: boolean;
  type: string;
  message: string;
  updatedAt?: Date;
  owner: {
    id: string;
    authId: string;
    displayName: string;
    username: string;
    domain: string;
    domainName: string;
  };
};
